import React from 'react';
import PropTypes from "prop-types";
import { Modal, Button } from 'rhombus-react';

import { noop } from 'utils/common';
import ConflictsTable from "./ConflictsTable";


export default function SkipMultipleModal(props) {
	const {
		conflicts,

		onConfirmSkip,
		onBack,
	} = props;

	function renderContent(){
		return (
			<div className="table-container">
				<p className="error-msg">The following assets already exist in the creative library and will be skipped.</p>
				<ConflictsTable conflicts={conflicts} />
			</div>
		);
	}

	function renderFooter(){
		return (
			<>
				<Button onClick={onBack} theme="default">Back</Button>
				<Button onClick={() => onConfirmSkip()}>Confirm Skipping</Button>
			</>
		);
	}

	let modalProps = {
		type: "modal",
		title: "Confirm Skipping Asset Upload",
		allowFullScreen: false,
		className: "upload-error-modal",
		xClose: false,
		bladeProps: {
			verticallyCenter: true,
		},
		renderContent,
		renderFooter,
	};

	return <Modal {...modalProps} />;
}

SkipMultipleModal.displayName = "SkipMultipleModal";

SkipMultipleModal.propTypes = {
	conflicts: PropTypes.arrayOf(PropTypes.shape({
		name: PropTypes.string,
		creatives: PropTypes.array,
	})),

	onConfirmSkip: PropTypes.func,
	onBack: PropTypes.func,
};

SkipMultipleModal.defaultProps = {
	conflicts: [],

	onConfirmSkip: noop,
	onBack: noop,
};
